import React from 'react';

export const FADE_R = 'radial-gradient(ellipse at bottom left, black 55%, transparent 80%)';
export const FADE_L = 'radial-gradient(ellipse at bottom right, black 55%, transparent 80%)';
export const BRAND_GRADIENT = 'linear-gradient(90deg, #E8A93C 0%, #C9A060 35%, #2F6FD0 70%, #1747A6 100%)';

export const BrandWordmark = ({ className = '' }) => (
  <div className={`flex flex-col items-center ${className}`}>
    <img src="/swami-logo.png" alt="Swami Software" className="h-24 sm:h-28 w-auto object-contain" data-testid="brand-logo" />
    <div className="flex items-center gap-5 mt-6 w-full max-w-md">
      <span className="h-px flex-1 bg-gradient-to-r from-transparent to-slate-400" />
      <span className="text-3xl sm:text-4xl font-semibold tracking-[0.3em] text-slate-700 pl-[0.3em]" style={{ fontFamily: 'Montserrat, Chivo, sans-serif' }}>OEE</span>
      <span className="h-px flex-1 bg-gradient-to-l from-transparent to-slate-400" />
    </div>
    <p className="mt-3 text-[11px] sm:text-sm font-semibold tracking-[0.35em] text-slate-500 text-center" style={{ fontFamily: 'Montserrat, Chivo, sans-serif' }}>OVERALL EQUIPMENT EFFICIENCY</p>
  </div>
);

export const BrandSplash = ({ fading = false }) => (
  <div className={`fixed inset-0 z-50 flex items-center justify-center bg-white overflow-hidden transition-opacity duration-500 ${fading ? 'opacity-0 pointer-events-none' : 'opacity-100'}`} data-testid="brand-splash">
    <img src="/loader-left.jpg" alt="" className="absolute left-0 bottom-0 w-[30vw] max-w-[500px] opacity-90 pointer-events-none select-none" style={{ WebkitMaskImage: FADE_R, maskImage: FADE_R }} />
    <img src="/loader-right.jpg" alt="" className="absolute right-0 bottom-0 w-[30vw] max-w-[500px] opacity-90 pointer-events-none select-none" style={{ WebkitMaskImage: FADE_L, maskImage: FADE_L }} />
    <div className="relative flex flex-col items-center splash-rise">
      <BrandWordmark />
      <div className="mt-12 h-2.5 w-72 sm:w-[480px] rounded-full bg-slate-200/80 overflow-hidden">
        <div className="h-full rounded-full splash-bar" style={{ background: BRAND_GRADIENT }} />
      </div>
      <p className="mt-4 text-xs font-semibold tracking-[0.35em] text-slate-600" style={{ fontFamily: 'Montserrat, Chivo, sans-serif' }}>LOADING APPLICATION...</p>
    </div>
    <style>{`
      @keyframes splashBar { 0% { width: 6%; } 60% { width: 72%; } 100% { width: 100%; } }
      .splash-bar { animation: splashBar 2.6s cubic-bezier(.4,0,.2,1) forwards; }
      @keyframes splashRise { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: none; } }
      .splash-rise { animation: splashRise .7s ease-out both; }
    `}</style>
  </div>
);
